import { render, staticRenderFns } from "./EditBulkConsultant.vue?vue&type=template&id=ab3dbc2c&"
import script from "./EditBulkConsultant.vue?vue&type=script&lang=js&"
export * from "./EditBulkConsultant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports